import React from 'react';
import logo from './logo.svg';

const LogoCompany = ({ size = 32 }) => (
  <img src={logo} alt="7Pay" style={{ height: size, display: 'block' }} />
);

export default LogoCompany;
